import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
} from "@mui/material";
import "./Homepage.css";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import background1 from "../../Assets/Background/background1.jpg";
import yogaPose2 from "../../Assets/Images/yogaPose2.png";
import ProfileImage1 from "../../Assets/ProfileImage/ProfileImage1.jpg";
import ProfileImage2 from "../../Assets/ProfileImage/ProfileImage2.jpg";
import ProfileImage3 from "../../Assets/ProfileImage/ProfileImage3.jpg";
import ProfileImage4 from "../../Assets/ProfileImage/ProfileImage4.jpg";
import { useNavigate } from "react-router-dom";

const guestVideos = [
  { id: "v7AYKMP6rOE", title: "Yoga for Beginners" },
  { id: "OQ6NfFIr2jw", title: "Morning Yoga Flow" },
  { id: "4pKly2JojMw", title: "Relaxing Evening Yoga" },
];

const level1Videos = [
  { id: "4pKly2JojMw", title: "Breathing Yoga" },
  { id: "OQ6NfFIr2jw", title: "Sun Salutations" },
  { id: "v7AYKMP6rOE", title: "Basic Poses" },
];

const teacherProfiles = [
  { name: "Emily Johnson", image: ProfileImage1 },
  { name: "Michael Smith", image: ProfileImage2 },
  { name: "Sophia Williams", image: ProfileImage3 },
];

const Homepage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [showLevel1, setShowLevel1] = useState(true);

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedIn);
  }, []);

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        {/* Background Image */}
        <img
          src={background1}
          alt="Yoga Pose"
          style={{
            objectFit: "cover",
          }}
          className="home-yoga-image"
        />

        {/* Text Content */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: { xs: "5%", sm: "8%", md: "10%" },
            transform: "translateY(-50%)",
            color: "#2e2e2e", // dark text (you can change to white if needed)
            zIndex: 1,
            maxWidth: { xs: "90%", sm: "60%", md: "40%" },
            backgroundColor: "#9797978e",
            borderRadius: "12px",
            padding: "18px",
          }}
          className="imagetext"
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              lineHeight: { xs: 1.2, sm: 1.3, md: 1.4 },
              mb: 2,
            }}
          >
            YOGA FIRST <br /> FITNESS ALWAYS
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 3,
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
              color: "#555",
              width: { xs: "90%", sm: "80%", md: "70%" },
            }}
            className="textparaonimage"
          >
            Welcome to Great Fitness, Los Angeles’ premier destination for yoga
            and fitness enthusiasts. Nestled in the vibrant heart of the city,
            we offer a sanctuary where mind, body, and spirit align.
          </Typography>

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#3b7d5c",
                color: "#fff",
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.2 },
                fontWeight: "bold",
                fontSize: { xs: "0.875rem", sm: "1rem" },
                "&:hover": {
                  backgroundColor: "#2e644a",
                },
              }}
            >
              Try Free Session
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          borderRadius: 0,
          maxWidth: "1300px",
          mx: "auto",
          boxShadow: "none",
        }}
      >
        <Box sx={{ textAlign: "center", mt: 4, pb: 3, px: 0 }}>
          <Typography variant="h4" sx={{ color: "#106870", mb: 2 }}>
            Classes for every level and need
          </Typography>

          <Typography variant="subtitle1" sx={{ color: "black", mb: 2 }}>
            Whether you’re a beginner or long-term practitioner, whether you
            just want to move your body or learn how it moves, you're welcome
            just as you are.
          </Typography>
          <Box>
            {/* ✅ Only for logged-in users: Level 0 section */}

            {isLoggedIn && (
              <Box sx={{ backgroundColor: "#f0f0f0", pb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                    px: 1,
                    cursor: "pointer",
                    flexDirection: "row", // Ensure items stay in a row
                    textAlign: "left", // Keep text left-aligned
                  }}
                  onClick={() => setShowLevel1((prev) => !prev)}
                  className="LevelContainer"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "baseline",
                      gap: 1,
                      ml: 2, // Adjust left margin for spacing
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: { xs: "1.1rem", sm: "1.3rem" }, // Smaller font size for both levels
                      }}
                    >
                      Level 1
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#555",
                        fontSize: { xs: "0.8rem", sm: "0.9rem" }, // Smaller font size for description
                      }}
                    >
                      – Designed for foundational learning and breath awareness
                    </Typography>
                  </Box>

                  <Typography
                    variant="h4"
                    sx={{
                      mr: 4, // Increased margin-right to create more space between the text and arrow
                      color: "#106870",
                      transform: showLevel1 ? "rotate(90deg)" : "rotate(0deg)",
                      transition: "transform 0.2s",
                      fontSize: { xs: "2rem", sm: "2.5rem" }, // Slightly smaller icon size
                    }}
                  >
                    &gt;
                  </Typography>
                </Box>

                {showLevel1 && (
                  <>
                    <Grid
                      container
                      spacing={4}
                      justifyContent="center"
                      sx={{ maxWidth: "1200px", mx: "auto" }}
                    >
                      {level1Videos.map((vid) => (
                        <Grid item xs={12} sm={6} md={4} key={vid.id}>
                          <Card
                            sx={{
                              width: { xs: "100%", sm: "100%", md: 320 },
                              mx: "auto",
                              borderRadius: 0,
                              height: "auto",
                            }}
                          >
                            <CardContent sx={{ p: 2 }}>
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                  aspectRatio: "16 / 9",
                                  borderRadius: 2,
                                  overflow: "hidden",
                                }}
                              >
                                <iframe
                                  src={`https://www.youtube.com/embed/${vid.id}`}
                                  title={vid.title}
                                  allowFullScreen
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    border: 0,
                                  }}
                                />
                              </Box>
                              <Typography
                                variant="h6"
                                gutterBottom
                                sx={{ textAlign: "center", mt: 2 }}
                              >
                                {vid.title}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Show More Button */}
                    <Button
                      variant="contained"
                      sx={{
                        background: "#3b7d5c",
                        display: "block",
                        mx: "auto",
                        mt: 4,
                        mb: 2,
                        textTransform: "none",
                        fontWeight: "bold",
                        px: 4,
                        borderRadius: 2,
                      }}
                      onClick={() => navigate("/levels")}
                    >
                      Show More
                    </Button>
                  </>
                )}
              </Box>
            )}

            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4, mt: 2 }}>
              Free Session
            </Typography>
            {/* ✅ Guest videos shown to all users */}
            <Grid
              container
              spacing={4}
              justifyContent="center"
              sx={{ maxWidth: "1200px", mx: "auto" }}
            >
              {guestVideos.map((vid) => (
                <Grid item xs={12} sm={6} md={4} key={vid.id}>
                  <Card
                    sx={{
                      width: { xs: "100%", sm: "100%", md: 320 },
                      mx: "auto",
                      borderRadius: 0,
                      height: "auto",
                    }}
                  >
                    <CardContent sx={{ p: 2 }}>
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          aspectRatio: "16 / 9",
                          borderRadius: 2,
                          overflow: "hidden",
                        }}
                      >
                        <iframe
                          src={`https://www.youtube.com/embed/${vid.id}`}
                          title={vid.title}
                          allowFullScreen
                          style={{
                            width: "100%",
                            height: "100%",
                            border: 0,
                          }}
                        />
                      </Box>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ textAlign: "center", mt: 2 }}
                      >
                        {vid.title}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Button
            variant="contained"
            endIcon={<span style={{ fontSize: "20px" }}>→</span>}
            sx={{
              mt: 3,
              px: 4,
              py: 1.5,

              background: "#3b7d5c",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "none",
              "&:hover": {
                background: "#3b7d5c",
                boxShadow: "none",
              },
            }}
          >
            Try Free Sessions
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "#f0f0f0",
          // padding: 4,
          borderRadius: 0,
          maxWidth: "1300px",
          mx: "auto",
          pt: 0,
          mt: 0,
          boxShadow: "none",
        }}
      >
        <Box sx={{ pb: 2, px: 0, paddingBottom: "32px" }}>
          <Typography
            variant="body1"
            sx={{ color: "#ff5c33", textAlign: "center", pt: 4 }}
          >
            Benifits
          </Typography>
          <Typography
            variant="h4"
            sx={{ color: "#106870", mb: 2, textAlign: "center" }}
          >
            Reasons to Join Us
          </Typography>

          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ maxWidth: "1200px", mx: "auto", px: 3 }}
          >
            {/* CARD 1 */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 2 }}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={1}>
                    <SelfImprovementIcon sx={{ mr: 1 }} />
                    <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                      Improve Flexibility
                    </Typography>
                  </Box>
                  {[
                    "Stretch and tone your muscles safely.",
                    "Increase your range of motion gradually.",
                    "Relieve stiffness and joint tension.",
                    "Enhance posture and body alignment.",
                  ].map((text, idx) => (
                    <Box
                      key={idx}
                      display="flex"
                      alignItems="flex-start"
                      mb={0.5}
                    >
                      <FiberManualRecordIcon
                        sx={{ fontSize: 8, mt: "5px", mr: 1 }}
                      />
                      <Typography variant="body2">{text}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>

            {/* CARD 2 */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 2 }}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={1}>
                    <PsychologyIcon sx={{ mr: 1 }} />
                    <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                      Boost Mental Clarity
                    </Typography>
                  </Box>
                  {[
                    "Enhance focus with mindful breathing techniques.",
                    "Reduce mental fatigue and sharpen attention.",
                    "Calm your mind with guided meditation practices.",
                    "Improve emotional balance and decision-making.",
                  ].map((text, idx) => (
                    <Box
                      key={idx}
                      display="flex"
                      alignItems="flex-start"
                      mb={0.5}
                    >
                      <FiberManualRecordIcon
                        sx={{ fontSize: 8, mt: "5px", mr: 1 }}
                      />
                      <Typography variant="body2">{text}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>

            {/* CARD 3 */}
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 2 }}>
                <CardContent>
                  <Box display="flex" alignItems="center" mb={1}>
                    <LocalFireDepartmentIcon sx={{ mr: 1 }} />
                    <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                      Burn Fat
                    </Typography>
                  </Box>
                  {[
                    "Torch calories with high-energy flows.",
                    "Boost metabolism for lasting fat burn.",
                    "Sculpt lean muscles with targeted poses.",
                    "Improve stamina and overall body tone.",
                  ].map((text, idx) => (
                    <Box
                      key={idx}
                      display="flex"
                      alignItems="flex-start"
                      mb={0.5}
                    >
                      <FiberManualRecordIcon
                        sx={{ fontSize: 8, mt: "5px", mr: 1 }}
                      />
                      <Typography variant="body2">{text}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box sx={{ pb: 4, px: 2, my: 4 }}>
        {/* Title */}
        <Typography
          variant="h4"
          sx={{ color: "#106870", mb: 2, textAlign: "center" }}
        >
          Expert guidance from top teachers
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            color: "black",
            maxWidth: 600,
            margin: "0 auto",
            mb: 4,
            textAlign: "center",
          }}
        >
          Practice and learn from our expert team of teachers dedicated to
          guiding you on your journey and ensuring you feel supported every step
          of the way.
        </Typography>

        <Grid container justifyContent="center" spacing={5}>
          {teacherProfiles.map((teacher, index) => (
            <Grid item key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Avatar
                  alt={teacher.name}
                  src={teacher.image}
                  sx={{
                    width: 200,
                    height: 200,
                    border: "3px solid #106870",
                    boxShadow: 3,
                    mb: 1,
                  }}
                />
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  {teacher.name}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Homepage;
